import { render, staticRenderFns } from "./ModalEditPromotion.vue?vue&type=template&id=34408bc6&scoped=true"
import script from "./ModalEditPromotion.vue?vue&type=script&lang=js"
export * from "./ModalEditPromotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34408bc6",
  null
  
)

export default component.exports